import * as React from 'react';
import { useSelector } from 'react-redux';

import { ChatHeaderCard } from '../../components/ChatHeader';
import { selectChatHeaderCard } from '../../selectors/chatHeaderCardSelector';
import { useApplicationContext } from '../../utils/applicationContext';
import { ChatHeaderOfferContainer } from '../ChatHeaderOfferContainer';

export const ChatHeaderCardPreviewContainer = () => {
  const { config } = useApplicationContext();

  const isCustomHeaderEnabled = config.get<boolean>('frontend-chats.customHeader.Enabled');

  const headerCard = useSelector(selectChatHeaderCard);

  if (!isCustomHeaderEnabled) {
    return <ChatHeaderOfferContainer />;
  }

  if (!headerCard) {
    return null;
  }

  return <ChatHeaderCard {...headerCard} />;
};
